import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { ComunicationService } from '../common/comunication.service';
import { Router } from '@angular/router';

@Component({
  //moduleId: module.id,
	selector: 'app-sidebar',
	templateUrl: 'sidebar.component.html'
})
export class SidebarComponent implements OnInit {

	@Input() evento: number;
	@Input() valuea: number;
	@Input() valueb: number;
	@Input() tipoVentana: string;

	constructor(private _comunicationService : ComunicationService, private router: Router) {}

	public methodScroll(elemento : string):void {
     //this._comunicationService.callMethodGeneral(elemento);
     switch (elemento) {
       case "office":
         this.router.navigate(["security/office"]);
         break;
        case "aplicacion":
         this.router.navigate(["security/aplicacion"]);
         break;
         case "rol":
         this.router.navigate(["security/rol"]);
         break;
         case "user":
         this.router.navigate(["security/user"]);
         break;
         case "access":
         this.router.navigate(["security/access"]);
         break;

         case "rolaccess":
         this.router.navigate(["security/rolaccess"]);
         break;
         case "roluser":
         this.router.navigate(["security/roluser"]);
         break;
         case "officeAplicacion":
         this.router.navigate(["security/officeAplicacion"]);
         break;
       default:
         break;
     }
  }

	ngOnInit() {
	}
}
